import type { PropsWithChildren } from "react";

import { Dialog, DialogTrigger, Popover } from "react-aria-components";

import { Button } from "#components/v2/Button";
import { UserIcon } from "#icons";
import { cn } from "#utils";

export interface UserMenuProps extends PropsWithChildren {
  username: string;
  onLogout: () => void;
  onPreferences?: () => void;
  collapsed?: boolean;
}

export function UserMenu({
  username,
  collapsed,
  onLogout,
  onPreferences,
  children,
}: UserMenuProps) {
  const showPreferences = Boolean(onPreferences);
  return (
    <DialogTrigger>
      <Button
        aria-label={username}
        className={cn(
          "flex w-[13rem] items-center gap-x-3 rounded-10 border-2 border-neutral-400 bg-interactive-tertiary-button-enabled-background px-xl py-lg font-normal text-text-primary shadow-[0_0_4px_0_#A0B7E4] hover:bg-overlay-medium",
          collapsed ? "w-12 justify-center" : "",
        )}
        variant="tertiary"
      >
        <UserIcon className="size-lg" />
        {!collapsed ? <span className="truncate">{username}</span> : null}
      </Button>
      <Popover placement={collapsed ? "top left" : "top"}>
        <Dialog className="flex w-[12.5rem] flex-col gap-y-1 rounded-md bg-transparent px-1 py-2 shadow-[0_0_4px_0_#A0B7E4] outline-none backdrop-blur-md">
          {({ close }) => (
            <>
              {children}
              <ol className="flex flex-col gap-y-1" role="menu">
                {showPreferences ? (
                  <Button
                    className="text-text-label-medium justify-center rounded-10 border-2 border-neutral-400 bg-overlay-medium px-xl py-lg text-center font-semibold shadow hover:bg-interactive-tertiary-button-hover-background"
                    onPress={() => {
                      onPreferences?.();
                      close();
                    }}
                    slot={null}
                    variant="tertiary"
                  >
                    Preferences
                  </Button>
                ) : null}
                <Button
                  className={cn(
                    "text-text-label-medium justify-center rounded-10 border-2 border-neutral-400 bg-overlay-medium px-xl py-lg text-center font-bold text-interactive-negative-button-enabled-foreground shadow hover:bg-interactive-negative-button-hover-background focus:bg-interactive-negative-button-focus-background",
                  )}
                  onPress={onLogout}
                  variant="plain"
                >
                  Log Out
                </Button>
              </ol>
            </>
          )}
        </Dialog>
      </Popover>
    </DialogTrigger>
  );
}
